<template>
  <div class="container" >
    <div class="header"><img src="../assets/logo.gif"></div>
    <div style="margin:auto">
      <slot></slot>
    </div>
  </div>
</template>
<style scoped>
.main-header {
  background-color: #fff;
}

.header {
  display: flex;
  position: fixed;
  z-index: 11;
  top: 0;
  left: 0;
  background-color: white;
  box-shadow: -3px -15px 14px 15px black;
  height: 60px;
  width: 100%;
}

.header img{
  height: 30px;
  margin: 15px;
}

:deep(.form) {
  background-color: #ffffff;
  position: relative;
  z-index: 10;
  /*    top: 76px;*/
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  box-shadow: -3px 2px 11px 0px #666666;
  border: solid darkred 3px;
  padding: 0 20px;
  color: black;
}
</style>
